import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { RotateCcw, Clock, ShieldCheck, AlertTriangle } from "lucide-react";

export default function Returns() {
  const { lang, t } = useLanguage();
  const points = lang === "ar"
    ? [
        { icon: Clock, title: "خلال 14 يوماً", desc: "يمكنك طلب الاسترجاع خلال 14 يوماً من تاريخ الاستلام." },
        { icon: ShieldCheck, title: "المنتج بحالته الأصلية", desc: "يجب أن يكون المنتج بكامل تغليفه الأصلي وبدون أي استخدام." },
        { icon: RotateCcw, title: "كيفية الاسترجاع", desc: "تواصل معنا عبر الواتساب وسنرسل مندوب لاستلام المنتج مجاناً داخل الإمارات." },
        { icon: AlertTriangle, title: "الاستثناءات", desc: "لا تشمل سياسة الاسترجاع شاشات الحماية المركبة أو المنتجات التالفة بسبب سوء الاستخدام." },
      ]
    : [
        { icon: Clock, title: "14-day window", desc: "Returns accepted within 14 days of delivery." },
        { icon: ShieldCheck, title: "Original condition", desc: "Item must be unused with original packaging intact." },
        { icon: RotateCcw, title: "How to return", desc: "Contact us via WhatsApp; we'll arrange a free pickup within the UAE." },
        { icon: AlertTriangle, title: "Exceptions", desc: "Installed screen protectors and items damaged by misuse are not eligible." },
      ];
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 page-enter" data-testid="returns-page">
      <div className="text-xs uppercase tracking-widest text-[#D4AF37] mb-2">M16</div>
      <h1 className="font-display text-4xl mb-3">{t("returns")}</h1>
      <p className="text-[#9CA3AF] mb-10">
        {lang === "ar"
          ? "رضاك أولويتنا — لو لم يعجبك المنتج، نسترجعه بكل سهولة."
          : "Your satisfaction matters — we make returns simple."}
      </p>
      <div className="space-y-4">
        {points.map((p, i) => (
          <div key={i} className="flex gap-4 p-5 border border-[#27272A] rounded-xl">
            <div className="w-10 h-10 rounded-lg bg-[#D4AF37]/10 border border-[#D4AF37]/40 flex items-center justify-center text-[#D4AF37] shrink-0">
              <p.icon size={18} />
            </div>
            <div>
              <div className="font-display text-base mb-1">{p.title}</div>
              <div className="text-sm text-[#9CA3AF] leading-relaxed">{p.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
